export default __webpack_public_path__ + "static/media/cone-cylinder_chart.4cd00dfe.jpg";